module.exports = __webpack_public_path__ + "static/headshot-samuel-keeley-3x.c342e5b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-samuel-keeley-3x.jpg
// module id = 532
// module chunks = 152909308826437